
export interface IInitializeModel {
    savedSearchId: number;
    savedSearchName: string;
}

export interface InitializeWorkspaceDataModel {
    workBookId: string;
    workBookName: string;
}

export interface IQuestionModel {
    question: string;
    sessionId: string;
    ianatimezone : string
}

export interface IFeedbackModel {
    sessionid: string;
    queryId: number;
    feedback: boolean;
    feedbackText: string;
}

export const ChatBotModule = {
    SavedSearch: "SavedSearch",
    GeneralLedger: "GeneralLedger",
    Journal: "Journal",
    WorkBook: "WorkBook",
} as const;
export type typeChatBotModule = typeof ChatBotModule[keyof typeof ChatBotModule];

export interface IEmailMessageRequest {
    to: string[];
    cc: string[];
    bcc: string[];
    subject: string;
    content: string;
    attachments: string;
    attachmentName: string;
    objectId: number | null;
    objectRecordId: number | null;
}